import store from 'react/redux/store/store';
import { possibleTabs } from 'react/redux/reducers/matchmaking';
import { isNetplayPageActive } from 'react/netplay/netplayPageState';

// A rank_change push. The result screen shows on the netplay page, but not in the
// match-only stream view, and loads its own chunk the first time it's needed.
export default async function receiveRankChange(rankChange) {
	if(!isNetplayPageActive() || store.getState().matchmaking.selectedTab === possibleTabs.match_only_view) {
		return;
	}
	const { default: showMatchResult } = await import(/* webpackChunkName: "MatchResult" */ 'react/matchResult/showMatchResult');
	showMatchResult(rankChange);
}
